import { combineReducers } from 'redux';

const crazyEggFeatureFlag = (state = false) => {
    const nextState = state;

    return nextState;
};

const cappedFeeExperimentFeatureFlag = (state = false) => state;

const isPackageChangeDowngradeEnabled = (state = false) => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    cappedFeeExperimentFeatureFlag,
    crazyEggFeatureFlag,
    isPackageChangeDowngradeEnabled,
});
